import chunk from 'lodash.chunk';

import { ReportChartMode } from 'business/shift-report/report/types';
import { ActivityTreeFullFragment, TaskFullFragment } from 'generated/graphql';

import { getUsedActivitiesList } from './services/activity';
import {
  setPaddingLeft,
  getPaddingLeft,
  padding,
  margin,
} from './services/metadata/chart';

const TASK_HEIGHT = 45;
const MIN_CHART_WIDTH = 960;

const taskInPages = {
  page1: 18,
  next: 32,
};

interface GetChartMetadataParams {
  activities: ActivityTreeFullFragment[];
  tasks: TaskFullFragment[];
  mode: ReportChartMode;
  node?: HTMLElement;
}

export function getChartMetadata({
  activities,
  tasks,
  mode,
  node,
}: GetChartMetadataParams) {
  let baseElement = node;
  if (!baseElement) {
    baseElement = document.body;
  }

  const activitiesList = getUsedActivitiesList(activities, tasks, mode, false);

  setPaddingLeft(activitiesList);
  const paddingLeft = getPaddingLeft();

  let width = baseElement.clientWidth - padding.right - paddingLeft;
  if (width < MIN_CHART_WIDTH) {
    width = MIN_CHART_WIDTH - padding.right - paddingLeft;
  }

  if (mode === 'view' && activitiesList.length > taskInPages.page1) {
    const groups = [
      activitiesList.slice(0, taskInPages.page1),
      ...chunk(activitiesList.slice(taskInPages.page1), taskInPages.next),
    ];
    const metadata = groups.map((group) => ({
      width,
      height: group.length * TASK_HEIGHT + margin.top + margin.bottom,
      activities: group,
    }));
    return metadata;
  }

  const metadata = [
    {
      width,
      height: activitiesList.length * TASK_HEIGHT + margin.top + margin.bottom,
      activities: activitiesList,
    },
  ];
  return metadata;
}
